const Version = () => <>v1.1.6</>

export default Version